import { defineStore } from "pinia";

export const useStaticAssets = defineStore("StaticAssets", {
    state: () => ({
        // S3 hosted assets
        profile: "https://kaamfu.s3.us-east-1.amazonaws.com/assets/profile.svg",
        business: "https://kaamfu.s3.us-east-1.amazonaws.com/assets/business.svg",
        employee: "https://kaamfu.s3.us-east-1.amazonaws.com/assets/employee.svg",
        startup: "https://kaamfu.s3.us-east-1.amazonaws.com/assets/startup.svg",
        help: "https://kaamfu.s3.us-east-1.amazonaws.com/assets/help.svg",
    }),
}); 